export default __webpack_public_path__ + "static/media/orange-tablet.3b6396a2.png";